"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFromInternalApi = getFromInternalApi;
exports.postToInternalApi = postToInternalApi;
exports.deleteFromInternalApi = deleteFromInternalApi;
exports.getCachedAssetFromApi = getCachedAssetFromApi;
const assets_1 = require("@aurora/shared-types/assets");
const constants_1 = require("@aurora/shared-types/developer/constants");
const UrlBuilder_1 = __importDefault(require("@aurora/shared-utils/helpers/urls/UrlHelper/UrlBuilder"));
const UrlHelper_1 = __importDefault(require("@aurora/shared-utils/helpers/urls/UrlHelper/UrlHelper"));
const log_1 = require("@aurora/shared-utils/log");
const bestfetch_1 = require("bestfetch");
const exenv_1 = require("exenv");
const SwitchBranchCookieHelper_1 = require("@aurora/shared-utils/helpers/developer/SwitchBranchCookieHelper");
const NextContextHelper_1 = __importDefault(require("./NextContextHelper"));
const index_1 = require("@aurora/shared-types/app/index");
const log = (0, log_1.getLog)(module);
const buildId = (_a = process.env.BUILD_ID) === null || _a === void 0 ? void 0 : _a.replaceAll('-', '');
function getBranchInfo() {
    const branchName = (0, SwitchBranchCookieHelper_1.getBranchNameFromCookie)();
    const isDevBranch = !(0, SwitchBranchCookieHelper_1.isMainBranch)(branchName);
    return {
        branchName,
        isDevBranch
    };
}
/**
 * Builds fetch args for a fetch request.  A required CSRF header is added for non-GET requests.
 * @param method
 * @param endpoint
 * @param branchInfo
 * @param payload
 */
function buildFetchArguments(method, endpoint, branchInfo, payload) {
    if (!exenv_1.canUseDOM) {
        throw new Error('This is only available on the client.');
    }
    const isGet = method === 'GET';
    const { csrfToken, tenant } = (0, NextContextHelper_1.default)();
    const csrfHeader = !isGet && csrfToken ? { 'X-Csrf-Token': csrfToken } : undefined;
    const { isDevBranch, branchName } = branchInfo;
    const branchHeader = isDevBranch
        ? { [constants_1.BRANCH_NAME_KEY]: branchName }
        : undefined;
    const urlBuilder = UrlBuilder_1.default.fromUrl(UrlHelper_1.default.prefixBasePath(tenant, endpoint));
    if (isGet && payload) {
        urlBuilder.addQuery(payload);
    }
    return {
        uri: urlBuilder.build(),
        options: {
            method,
            credentials: 'same-origin',
            headers: Object.assign(Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, csrfHeader), branchHeader),
            body: !isGet && payload ? JSON.stringify(payload) : undefined
        }
    };
}
/**
 * Makes a get call to an internal endpoint.
 * NOTE: this is meant to be used for client side code only.
 * @param endpoint
 * @param parameters Optional request params
 */
function getFromInternalApi(endpoint, parameters) {
    const { uri, options } = buildFetchArguments('GET', endpoint, getBranchInfo(), parameters);
    return fetch(uri, options);
}
/**
 * Makes a post call to an internal endpoint with the necessary CSRF token.
 * NOTE: this is meant to be used for client side code only.
 * @param endpoint
 * @param payload An optional body
 */
function postToInternalApi(endpoint, payload) {
    const { uri, options } = buildFetchArguments('POST', endpoint, getBranchInfo(), payload);
    return fetch(uri, options);
}
/**
 * Makes a delete call to an internal endpoint with the necessary CSRF token.
 * NOTE: this is meant to be used for client side code only.
 * @param endpoint
 */
function deleteFromInternalApi(endpoint) {
    const { uri, options } = buildFetchArguments('DELETE', endpoint, getBranchInfo());
    return fetch(uri, options);
}
/**
 * Calls the config API for the specified overrides (or defaults).
 * @param type The config override type
 * @param ids the id or ids of the item to fetch
 * @param appType the app type
 * @param lastModified an optional last modified date of the item
 */
function getCachedAssetFromApi(type, ids, appType, lastModified) {
    return __awaiter(this, void 0, void 0, function* () {
        const identifier = ids
            .filter(id => (id === null || id === void 0 ? void 0 : id.length) > 0)
            .map(token => encodeURIComponent(token))
            .join('|');
        const branchInfo = getBranchInfo();
        const { isDevBranch, branchName } = branchInfo;
        const date = isDevBranch
            ? assets_1.LastModifiedKeys.BYPASS_OVERRIDE_CACHE
            : lastModified
                ? encodeURIComponent(lastModified)
                : assets_1.LastModifiedKeys.DEFAULTS_ONLY;
        const endpoint = `${appType === index_1.AppType.ADMIN ? '/admin' : ''}/api/asset/${type}/${identifier}-${date}-${buildId}.json`;
        const params = {};
        if (isDevBranch) {
            params.branch = branchName;
        }
        const { uri, options } = buildFetchArguments('GET', endpoint, branchInfo, params);
        const response = yield (0, bestfetch_1.bestfetch)(uri, options);
        if (!response.ok) {
            log.error(`Invalid response from ${type} endpoint: %s`, uri);
        }
        return response.data;
    });
}
//# sourceMappingURL=ApiHelper.js.map